import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController, ModalController } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';

import { TenderMarketing, DokumenMarketing as Dokumen, UserMarketing as User, MasterMarketing as Master } from '@providers/index';
import { DetailImagePage, SelectPage } from '../';

@Component({
  selector: 'page-form-post-tender',
  templateUrl: 'page.html'
})
export class FormPostTenderPage {

  form:any = {
    id : '',
    tender_id : '',
    tender_title : '',
    company_winner_id : '',
    company_winner_name: '',
    currency_id: '',
    currency_name : '',
    value : '',
    desc : '',
    document_id : '',
    generated_name : ''
  };
  akses  : any = {};
  loading: any;
  img_url='';
  list_currency = [];
  
  constructor(
    public navCtrl    : NavController,
    public navParams  : NavParams,
    private toastCtrl : ToastController,
    public loadingCtrl: LoadingController,
    public modalCtrl  : ModalController,
    public camera     : Camera,
    public userApi    : User,
    public tenderApi   : TenderMarketing,
    public dokumenApi : Dokumen,
    public masterApi  : Master
  ) {
    this.akses = this.userApi.akses;
    this.img_url = this.dokumenApi.file_url;

    this.form   = this.navParams.get('data');

    console.log("akses => ", this.akses);
    console.log("data => ", this.form);

    this.getCurrency();
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  ionViewDidEnter(){
    this.showLoading();
    this.loading.dismiss();
  }
 
  save(){
    
    if(this.form.tender_id==0){
      this.presentToast('Gagal simpan, Tender tidak boleh kosong.');
      return;
    }
    if(this.form.company_winner_id==0){
      this.presentToast('Gagal simpan,Company Winner tidak boleh kosong.');
      return;
    }
    if(this.form.currency_id==0){
      this.presentToast('Gagal simpan,Company Winner tidak boleh kosong.');
      return;
    }
    if(this.form.value==''){
      this.presentToast('Gagal simpan, Value tidak boleh kosong.');
      return;
    }

    this.showLoading();

    let params = {
      id                : this.form.id,
      desc              : this.form.desc,
      document_id       : this.form.document_id,
      tender_id         : this.form.tender_id,
      company_winner_id : this.form.company_winner_id,
      currency_id       : this.form.currency_id,
      value             : this.form.value
    };
    this.tenderApi.postPostTender(params).subscribe((resp:any) => {
      this.presentToast(resp.msg);
      this.loading.dismiss();
      this.navCtrl.pop();
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });
  }

  selectCompanyWinner(){
    let myModal = this.modalCtrl.create(SelectPage, { select_mod : 3 });
    myModal.onDidDismiss(data => {
      if(data.item){
        this.form.company_winner_id   = data.item.id,
        this.form.company_winner_name = data.item.company_name
      }
    });
    myModal.present();
  }

  takePicture(camera=1){
    const options: CameraOptions = {
      quality: 25,
      destinationType: this.camera.DestinationType.DATA_URL,
      targetWidth : 1024,
      sourceType:camera
    }
    
    this.camera.getPicture(options).then((imageData) => {
     // imageData is either a base64 encoded string or a file URI
     // If it's base64 (DATA_URL):
     let base64Image = 'data:image/jpeg;base64,' + imageData;
     this.save_image(base64Image);
    }, (err) => {
     // Handle error
    });
  }

  save_image(img){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {img: img};
    this.dokumenApi.post(params).subscribe((resp:any) => {
      this.form.document_id    = resp.data.id;
      this.form.generated_name = resp.data.generated_name;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  viewImage() {
    let profileModal = this.modalCtrl.create(DetailImagePage, { 
      url_image : this.img_url+this.form.generated_name
    });
    profileModal.present();
  }

  getCurrency(){
    this.masterApi.getCurrency().subscribe((resp:any) => {
      this.list_currency = resp.data;
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/marketing/form_post_tender/page.ts